import AiAssistant from "./ai_assistant.vue"

const route = {
    path: "aiAssistant",
    component: AiAssistant
}

export default route
